import { mapState } from 'vuex';
import f from "@/application/shared/functions.js"
import footerComponent from '../footerComponent/index.vue'

export default {
	name: 'signin',

	components : {
		footerComponent
	},
	data : function(){

		return {
			loading : false
		}

	},

	created : function(){
	},

	watch: {
		//$route: 'getdata'
	},

	computed: mapState({
		auth : state => state.auth,
		ioscordova : function(){
			return f.isios() && window.cordova
		},

		ios : function(){
			return f.isios() && !window.cordova
		},

		hasgoogle : function(){
			return !f.isios()
		}
	}),

	methods : {

		toauthorization : function(){
			this.$router.push('/authorization').catch(e => {})
		},

		applesigninweb : function(){

			this.core.authways.signin.appleweb()

			/*this.$store.commit('globalpreloader', true)

            this.core.authways.signin.apple().then(r => {
                this.$store.commit('lastlogin','')
            }).catch( e => {

				console.error(e)

				this.core.sitemessage(this.$i18n.t("labels.appleSignInFailed"))

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})*/
        },
	  
		applesignin : function(){

			this.$store.commit('globalpreloader', true)

            this.core.authways.signin.apple().then(r => {
                this.$store.commit('lastlogin','')
            }).catch( e => {

				console.error(e)

				this.core.sitemessage(this.$i18n.t("labels.appleSignInFailed"))

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})
        },
        googlesignin : function(){

			this.$store.commit('globalpreloader', true)

            this.core.authways.signin.google().then(r => {

                this.$store.commit('lastlogin','')

            }).catch(e => {

				console.error(e)

				this.core.sitemessage(this.$i18n.t("labels.googleSignInFailed"))

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})
			
			/*.then(r => {

                this.$store.commit('lastlogin','')

            }).catch(e => {

				console.error(e)

                this.$message({
                    title : this.$i18n.t("labels.failed"),
                    message : this.$i18n.t("labels.googleSignInFailed")
                })

            }).finally(() => {
				this.$store.commit('globalpreloader', false)
			})*/
        },


		toregistration : function(){
			this.$router.push('/registration').catch(e => {})
		},

	   
	},

	props: {
		caption : String
	},

}